export class FacilityUser {
  constructor(readonly id: string) {}
}
